import WebhookManagement from './WebhookManagement';
import APIKeyManagement from './APIKeyManagement';
import MetaAdsIntegration from './MetaAdsIntegration';
import { INTEGRATIONS } from '../../utils/constant';

const integrationRoutes = [
  {
    path: '/integrations/webhooks',
    element: <WebhookManagement />,
    permission: INTEGRATIONS,
  },
  {
    path: '/integrations/api-keys',
    element: <APIKeyManagement />,
    permission: INTEGRATIONS,
  },
  {
    path: '/integrations/meta-ads',
    element: <MetaAdsIntegration />,
    permission: INTEGRATIONS,
  },
];

export default integrationRoutes;
